import { CLEAR_HELP_TEXT, SET_HELP_TEXT } from '../actionTypes'

const initialState = {}


export default (state=initialState,  action) => {
    switch(action.type) {
    case SET_HELP_TEXT:
      return action.helpText
    case CLEAR_HELP_TEXT:
      return initialState
    default:
        return state
    }
    
}